import React from 'react';
import './BookingPage.css';

import { PageTitle } from '../../../components';
import { Booking } from '../../../sections';



const BookingPage = () => {

  return (

    <div className='booking-page'>

      {/* Page Title */}
      <PageTitle title={'Booking'} page={'Booking'} />

      {/* Booking Form */}
      <Booking />

    </div>

  );

}

export default BookingPage;